import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class DocumentService {
  // 文档上传关联文件
  static async uploadReleFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/upload_rele_file', payload)
    )
    return Callback(err, res)
  }
  // 获取文档基本属性
  static async findDocAttr(params) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/get-document?${qs.stringify(params)}`)
    )
    return Callback(err, res)
  }
  // 获取文件详情
  static async getDocumentFiles(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/get_document_files?${qs.stringify(payload)}`)
    )
    return [err, res]
  }
  // 获取实现文件
  static async findFile(params) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/basedata/documentfile/${params.fileId}`)
    )
    return Callback(err, res)
  }
  // 获取实现文件列表
  static async findFileList(params) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/get_document_files?id=${params.documentId}`)
    )
    return Callback(err, res)
  }
  // static async findFileList(params) {
  //   const [err, res] = await To(
  //     wizStandardInstance.get(
  //       `/api/Document/GetFileListAsync/${params.documentId}${
  //         params.isUnionObsoletedocument
  //           ? `?isUnionObsoletedocument=${params.isUnionObsoletedocument}`
  //           : ''
  //       }`
  //     )
  //   )
  //   return Callback(err, res)
  // }
  // 获取文档关联位号对象类别
  static async findTagClassAssociation(params) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/tag/documentfile_tagclass_association/${params.fileId}?${qs.stringify(params)}`
      )
    )
    return Callback(err, res)
  }
  // 获取文档关联位号
  static async findTagAssociation(params) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag/documentfile_tag_association?${qs.stringify(params)}`)
    )
    return Callback(err, res)
  }
  // 获取位号详情
  static async findTagByFile(params) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag/tag_by_file?${qs.stringify(params)}`)
    )
    return Callback(err, res)
  }
  // 获取关联位号数据
  static async findCoorelateData(params) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Document/GetFileCorrelateTagsAsync/${params.fileId}`)
    )
    return Callback(err, res)
  }
  // 解除位号关联关系
  static async dissolveRelationShip(params) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/std/TagFileAssociation/relieve_associated_with_document_file_async/${params.fileId}`,
        params.tagIdList
      )
    )
    return Callback(err, res)
  }
  // 获取类别下拉选项
  static async findClassOptions(params) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/TagClass/GetTagClassTreeAsync/${params.id}`)
    )
    return Callback(err, res)
  }
  // 获取关联关系列表
  static async findRelationList(params) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Tag/file-rele-tag-page-list', params)
    )
    return Callback(err, res)
  }
  // 新建关联关系
  static async associateTagWithDocumentFile(params) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/TagFileAssociation/addtagfileassociationlist', params)
    )
    return Callback(err, res)
  }
  // 根据位号获取关联位号
  static async findRelationTagsByTagCode(params) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Tag/GetRelationDataByTagCodeAsync', params)
    )
    return Callback(err, res)
  }
  // 根据位号获取关联文档
  static async findRelationFileByTagCode(params) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Tag/GetRelationDataByFileCodeAsync', params)
    )
    return Callback(err, res)
  }
  // 获取playerOption的系统参数
  static async findPlayerParam(params) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/SystemSetting/query_system_params_async', params)
    )
    return Callback(err, res)
  }
  // 获取文档关联关系
  static async findRelationDoc(params) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/tag/GetTagObjDataAsync/${params.tagId}/${params.page}/${params.pageNum}`
      )
    )
    return Callback(err, res)
  }
  // 获取加载文件的路径
  static async findFileUrl(params) {
    const [err, res] = await To(wizStandardInstance.get(`/file/getfilecontentasync/${params.id}`))
    return Callback(err, res)
  }
  // 判断进入页面的文件类型
  static async getDocumentFileType(params) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/single-file?${qs.stringify(params)}`)
    )
    return Callback(err, res)
  }
  // svg新增活化热点
  static async addSvgHotTags(params) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/add_svg_file_content', params)
    )
    return Callback(err, res)
  }
  // svg编辑活化热点
  static async updateSvg(id, params) {
    const [err, res] = await To(
      wizStandardInstance.post(`/api/std/Document/update_svg_file_content/${id}`, params)
    )
    return Callback(err, res)
  }
  // 获取当前项目下的模型的集合（包含经纬度的）
  static async getModelInfos(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Document/get_model_list_xj/${payload.siteId}/${payload.keywords}`
      )
    )
    return Callback(err, res)
  }
  // 云渲染上面使用的获取tag位号带详情的列表
  static async getTagDetailList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag/handover/cloud_display/tag_tree?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 查看卷册
  static async getDocumentByTagCode(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Document/get_documentByTagCode?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 通过code直接获取详情
  static async getTagInfoByCode(payload) {
    const [err, res] = await To(
      axios.get(`/api/tag/handover/singlebycode-withdetail?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 修改基本属性
  static async updateDataDetail(params) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/add_or_update_data_detail', params)
    )
    return Callback(err, res)
  }
  // 获取文件可关联的对象列表
  static async getFileReleTagList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Tag/file-rele-tag-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 批量新增关联关系
  static async batchAddTagFileAssociation(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/TagFileAssociation/many', payload)
    )
    return Callback(err, res)
  }
  // 获取文件可关联的对象列表
  static async getTagsList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Tag/tags?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 批量新增关联关系
  static async editSvgFileContent(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/edit_svg_file_content', payload)
    )
    return Callback(err, res)
  }
}
